type imgActionOptionsType = {
    noAction: 0,
    internalUrl: 1,
    externalUrl: 2,
    popUpOpen: 3,
    customAction: 4,
}
export const imgActionOptions: imgActionOptionsType = {
    noAction: 0,
    internalUrl: 1,
    externalUrl: 2,
    popUpOpen: 3,
    customAction: 4,
}

export type imgActionOptionsValues = typeof imgActionOptions[keyof typeof imgActionOptions]

export default interface IHomeBanner {
    imgUrl: string,
    imgUrlMobile?: string,
    imgAlt?: string,
    imgAction?: imgActionOptionsValues,
    imgActionUrl?: string,
    newAppVersionNotification?: string,
    popUpId?: string,
    popUpAuto?: boolean,
    popUpHeader?: string,
    popUpText?: string,
    popUpImgUrl?: string,
    popUpVideoUrl?: string,
    popUpLinkUrl?: string,
}

export const HomeBannerDefault: IHomeBanner = {
    imgUrl: ''
}